import { FileDown } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const PdfPreview = ({ url, onClose, onDownload }) => (
  <Dialog open={!!url} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-4xl w-[95vw] h-[90vh] flex flex-col bg-slate-900 border-slate-700" data-testid="pdf-preview-modal">
      <DialogHeader className="flex-row items-center justify-between space-y-0 pr-8">
        <DialogTitle>Anteprima PDF cliente</DialogTitle>
        <Button size="sm" onClick={onDownload} data-testid="pdf-preview-download-btn"><FileDown className="h-4 w-4 mr-2" />Scarica</Button>
      </DialogHeader>
      {url && <iframe title="Anteprima preventivo" src={url} className="flex-1 w-full rounded bg-white" data-testid="pdf-preview-frame" />}
    </DialogContent>
  </Dialog>
);
